class Alipay {
    constructor() {
        this.scriptUrl = "https://appx/web-view.min.js"
        this.name = "alipay"
    }
    navigateTo(src) {
        my.navigateTo({
            url:'/'+src
        });
    }
    navigateBack(){
        my.navigateBack({})
    }
    reLaunchTo(src) {
        my.reLaunch({
            url:'/'+src
        });
    }
    redirectTo(src) {
        my.redirectTo({
            url:'/'+src
        });
    }
    makePhoneCall(tel) {
        console.log(tel)
        location.href=`tel:${tel}`;
    }
    qiyu(){
        location.href="https://wxlqkjyxgs.qiyukf.com/client?k=90d344f50c3d6ac29e60360bae8e8639&wp=1&robotShuntSwitch=1&robotId=3425033&sid=3889771"
    }
	//与小程序之间的双向通道
	postMessage(obj) {
	    my.postMessage(obj)
	}
	onMessage(fn) {
	    my.onMessage=fn;
	}
    //判断当前环境是否是微信小程序
    isme() {
        return navigator.userAgent.indexOf('AlipayClient') > -1;
    }
}
export default new Alipay()